import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";
/* Booking system pages */
const DoctorsPage = Loadable(lazy(() => import("src/pages/booking/doctors/view")));
const RolesPage = Loadable(lazy(() => import("src/pages/booking/roles/view")));
const RoomsPage = Loadable(lazy(() => import("src/pages/booking/rooms/view")));
const ServicesPage = Loadable(lazy(() => import("src/pages/booking/services/view")));
const ServicePricelistPage = Loadable(lazy(() => import("src/pages/booking/services/pricelist/view")));
const ClientCategoriesPage = Loadable(lazy(() => import("src/pages/booking/client-categories/view")));
const ClientsPage = Loadable(lazy(() => import("src/pages/booking/clients/view")));
const ReferralsPage = Loadable(lazy(() => import("src/pages/booking/referrals/view")));
const ClientAccountPage = Loadable(lazy(() => import("src/pages/booking/client-account/view")));
const MedicalHistoryPage = Loadable(lazy(() => import("src/pages/booking/medical-history/view")));
const PlanCategoriesPage = Loadable(lazy(() => import("src/pages/booking/plan-categories/view")));
const TreatmentPlansPage = Loadable(lazy(() => import("src/pages/booking/treatment-plans/view")));
const AppointmentsPage = Loadable(lazy(() => import("src/pages/booking/appointments/view")));
const BookingCalendarPage = Loadable(lazy(() => import("src/pages/booking/calendar/view")));
const InvoicesPage = Loadable(lazy(() => import("src/pages/booking/invoices/view")));
const ReceiptsPage = Loadable(lazy(() => import("src/pages/booking/receipts/view")));
const ExpensesTypesPage = Loadable(lazy(() => import("src/pages/booking/expenses-types/view")));
const ExpensesListPage = Loadable(lazy(() => import("src/pages/booking/expenses-list/view")));
const PaymentVouchersPage = Loadable(lazy(() => import("src/pages/booking/payment-vouchers/view")));
const ExpensesAccountsPage = Loadable(lazy(() => import("src/pages/booking/expenses-accounts/view")));
const FixedIncomePage = Loadable(lazy(() => import("src/pages/booking/fixed-income/view")));

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

/* ****Pages***** */
const AdminLogs = Loadable(lazy(() => import("src/pages/admins_logs/view")));

const EcommerceDash = Loadable(
  lazy(() => import("../views/dashboard/Home"))
);
const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view"))
);

/* ****Apps***** */
const Chats = Loadable(lazy(() => import("../views/apps/chat/Chat")));
const Notes = Loadable(lazy(() => import("../views/apps/notes/Notes")));
const Calendar = Loadable(
  lazy(() => import("../views/apps/calendar/BigCalendar"))
);
const Email = Loadable(lazy(() => import("../views/apps/email/Email")));
const Blog = Loadable(lazy(() => import("../views/apps/blog/Blog")));
const BlogDetail = Loadable(lazy(() => import("../views/apps/blog/BlogPost")));
const Tickets = Loadable(lazy(() => import("../views/apps/tickets/Tickets")));
const Contacts = Loadable(
  lazy(() => import("../views/apps/contacts/Contacts"))
);
const Ecommerce = Loadable(
  lazy(() => import("../views/apps/eCommerce/Ecommerce"))
);
const EcommerceDetail = Loadable(
  lazy(() => import("../views/apps/eCommerce/EcommerceDetail"))
);
const EcomProductList = Loadable(
  lazy(() => import("../views/apps/eCommerce/EcomProductList"))
);
const EcomProductCheckout = Loadable(
  lazy(() => import("../views/apps/eCommerce/EcommerceCheckout"))
);
const UserProfile = Loadable(
  lazy(() => import("../views/apps/user-profile/UserProfile"))
);
const Followers = Loadable(
  lazy(() => import("../views/apps/user-profile/Followers"))
);
const Friends = Loadable(
  lazy(() => import("../views/apps/user-profile/Friends"))
);
const Gallery = Loadable(
  lazy(() => import("../views/apps/user-profile/Gallery"))
);

// Pages
const RollbaseCASL = Loadable(
  lazy(() => import("../views/pages/rollbaseCASL/RollbaseCASL"))
);
const Treeview = Loadable(
  lazy(() => import("../views/pages/treeview/Treeview"))
);
const Pricing = Loadable(lazy(() => import("../views/pages/pricing/Pricing")));
const AccountSetting = Loadable(
  lazy(() => import("../views/pages/account-setting/AccountSetting"))
);
const Faq = Loadable(lazy(() => import("../views/pages/faq/Faq")));

// widget
const WidgetCards = Loadable(
  lazy(() => import("../views/widgets/cards/WidgetCards"))
);
const WidgetBanners = Loadable(
  lazy(() => import("../views/widgets/banners/WidgetBanners"))
);
const WidgetCharts = Loadable(
  lazy(() => import("../views/widgets/charts/WidgetCharts"))
);

// form elements
const MuiAutoComplete = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiAutoComplete"))
);
const MuiButton = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiButton"))
);
const MuiCheckbox = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiCheckbox"))
);
const MuiRadio = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiRadio"))
);
const MuiSlider = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiSlider"))
);
const MuiDateTime = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiDateTime"))
);
const MuiSwitch = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiSwitch"))
);

// form layout
const FormLayouts = Loadable(lazy(() => import("../views/forms/FormLayouts")));
const FormCustom = Loadable(lazy(() => import("../views/forms/FormCustom")));
const FormWizard = Loadable(lazy(() => import("../views/forms/FormWizard")));
const FormValidation = Loadable(
  lazy(() => import("../views/forms/FormValidation"))
);
const QuillEditor = Loadable(
  lazy(() => import("../views/forms/quill-editor/QuillEditor"))
);
const FormHorizontal = Loadable(
  lazy(() => import("../views/forms/FormHorizontal"))
);
const FormVertical = Loadable(
  lazy(() => import("../views/forms/FormVertical"))
);

// tables
const BasicTable = Loadable(lazy(() => import("../views/tables/BasicTable")));
const CollapsibleTable = Loadable(
  lazy(() => import("../views/tables/CollapsibleTable"))
);
const EnhancedTable = Loadable(
  lazy(() => import("../views/tables/EnhancedTable"))
);
const FixedHeaderTable = Loadable(
  lazy(() => import("../views/tables/FixedHeaderTable"))
);
const PaginationTable = Loadable(
  lazy(() => import("../views/tables/PaginationTable"))
);
const SearchTable = Loadable(lazy(() => import("../views/tables/SearchTable")));

// chart
const LineChart = Loadable(lazy(() => import("../views/charts/LineChart")));
const GredientChart = Loadable(
  lazy(() => import("../views/charts/GredientChart"))
);
const DoughnutChart = Loadable(
  lazy(() => import("../views/charts/DoughnutChart"))
);
const AreaChart = Loadable(lazy(() => import("../views/charts/AreaChart")));
const ColumnChart = Loadable(lazy(() => import("../views/charts/ColumnChart")));
const CandlestickChart = Loadable(
  lazy(() => import("../views/charts/CandlestickChart"))
);
const RadialbarChart = Loadable(
  lazy(() => import("../views/charts/RadialbarChart"))
);

// ui
const MuiAlert = Loadable(
  lazy(() => import("../views/ui-components/MuiAlert"))
);
const MuiAccordion = Loadable(
  lazy(() => import("../views/ui-components/MuiAccordion"))
);
const MuiAvatar = Loadable(
  lazy(() => import("../views/ui-components/MuiAvatar"))
);
const MuiChip = Loadable(lazy(() => import("../views/ui-components/MuiChip")));
const MuiDialog = Loadable(
  lazy(() => import("../views/ui-components/MuiDialog"))
);
const MuiList = Loadable(lazy(() => import("../views/ui-components/MuiList")));
const MuiPopover = Loadable(
  lazy(() => import("../views/ui-components/MuiPopover"))
);
const MuiRating = Loadable(
  lazy(() => import("../views/ui-components/MuiRating"))
);
const MuiTabs = Loadable(lazy(() => import("../views/ui-components/MuiTabs")));
const MuiTooltip = Loadable(
  lazy(() => import("../views/ui-components/MuiTooltip"))
);
const MuiTransferList = Loadable(
  lazy(() => import("../views/ui-components/MuiTransferList"))
);
const MuiTypography = Loadable(
  lazy(() => import("../views/ui-components/MuiTypography"))
);

// authentication
const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login"))
);

const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("src/views/authentication/auth/ResetPassword"))
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);

const getDefaultRouteBasedOnPrivileges = () => {
  const data = getLocalStorage(dataLocalStorage.privileges);
  const routes = [
    ["21", RouterName.dashboard],
    ["1", RouterName.admins.admins],
    ["12", RouterName.booking.appointments],
    ["8", RouterName.booking.clients],
    ["3", RouterName.booking.doctors],
    ["6", RouterName.booking.services],
    ["13", RouterName.booking.calendar],
    ["2", RouterName.admins_logs.admins_logs],
    ["4", RouterName.booking.roles],
    ["5", RouterName.booking.rooms],
    ["7", RouterName.booking.clientCategories],
    ["14", RouterName.booking.invoices],
  ];
  for (const [id, path] of routes) {
    if (data[id]?.access_read == 1) return path;
  }
  return RouterName.dashboard;
};

let data = getLocalStorage(dataLocalStorage.privileges);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      {
        path: "/",
        exact: true,
        element: (
          <Navigate to={getDefaultRouteBasedOnPrivileges()} />
        ),
      },

      data["1"]?.access_read == 1 && {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },
      data["1"]?.access_read == 1 && {
        path: RouterName.admins.privileges,
        exact: true,
        element: <PrivilegesPage />,
      },
      data["2"]?.access_read == 1 && {
        path: RouterName.admins_logs.admins_logs,
        exact: true,
        element: <AdminLogs />,
      },
      data["3"]?.access_read == 1 && {
        path: RouterName.booking.doctors,
        exact: true,
        element: <DoctorsPage />,
      },
      data["4"]?.access_read == 1 && {
        path: RouterName.booking.roles,
        exact: true,
        element: <RolesPage />,
      },
      data["5"]?.access_read == 1 && {
        path: RouterName.booking.rooms,
        exact: true,
        element: <RoomsPage />,
      },
      data["6"]?.access_read == 1 && {
        path: RouterName.booking.services,
        exact: true,
        element: <ServicesPage />,
      },
      data["6"]?.access_read == 1 && {
        path: RouterName.booking.servicePricelist,
        exact: true,
        element: <ServicePricelistPage />,
      },
      data["7"]?.access_read == 1 && {
        path: RouterName.booking.clientCategories,
        exact: true,
        element: <ClientCategoriesPage />,
      },
      data["8"]?.access_read == 1 && {
        path: RouterName.booking.clients,
        exact: true,
        element: <ClientsPage />,
      },
      data["8"]?.access_read == 1 && {
        path: RouterName.booking.referrals,
        exact: true,
        element: <ReferralsPage />,
      },
      data["16"]?.access_read == 1 && {
        path: RouterName.booking.clientAccount,
        exact: true,
        element: <ClientAccountPage />,
      },
      data["9"]?.access_read == 1 && {
        path: RouterName.booking.medicalHistory,
        exact: true,
        element: <MedicalHistoryPage />,
      },
      data["10"]?.access_read == 1 && {
        path: RouterName.booking.planCategories,
        exact: true,
        element: <PlanCategoriesPage />,
      },
      data["11"]?.access_read == 1 && {
        path: RouterName.booking.treatmentPlans,
        exact: true,
        element: <TreatmentPlansPage />,
      },
      data["12"]?.access_read == 1 && {
        path: RouterName.booking.appointments,
        exact: true,
        element: <AppointmentsPage />,
      },
      data["13"]?.access_read == 1 && {
        path: RouterName.booking.calendar,
        exact: true,
        element: <BookingCalendarPage />,
      },
      data["14"]?.access_read == 1 && {
        path: RouterName.booking.invoices,
        exact: true,
        element: <InvoicesPage />,
      },
      data["15"]?.access_read == 1 && {
        path: RouterName.booking.receipts,
        exact: true,
        element: <ReceiptsPage />,
      },
      data["17"]?.access_read == 1 && {
        path: RouterName.booking.expensesTypes,
        exact: true,
        element: <ExpensesTypesPage />,
      },
      data["18"]?.access_read == 1 && {
        path: RouterName.booking.expensesList,
        exact: true,
        element: <ExpensesListPage />,
      },
      data["19"]?.access_read == 1 && {
        path: RouterName.booking.paymentVouchers,
        exact: true,
        element: <PaymentVouchersPage />,
      },
      data["20"]?.access_read == 1 && {
        path: RouterName.booking.expensesAccounts,
        exact: true,
        element: <ExpensesAccountsPage />,
      },
      data["22"]?.access_read == 1 && {
        path: RouterName.booking.fixedIncome,
        exact: true,
        element: <FixedIncomePage />,
      },
      (data["21"]?.access_read == 1 || !data) && {
        path: RouterName.dashboard,
        exact: true,
        element: <EcommerceDash />,
      },
      {
        path: RouterName.doc.dashboard,
        exact: true,
        element: <EcommerceDash />,
      },
      { path: "/apps/chats", element: <Chats /> },
      { path: "/apps/notes", element: <Notes /> },
      { path: "/apps/calendar", element: <Calendar /> },
      { path: "/apps/email", element: <Email /> },
      { path: "/apps/tickets", element: <Tickets /> },
      { path: "/apps/contacts", element: <Contacts /> },
      { path: "/apps/ecommerce/shop", element: <Ecommerce /> },
      { path: "/apps/blog/posts", element: <Blog /> },
      { path: "/apps/blog/detail/:id", element: <BlogDetail /> },
      {
        path: "/apps/ecommerce/eco-product-list",
        element: <EcomProductList />,
      },
      {
        path: "/apps/ecommerce/eco-checkout",
        element: <EcomProductCheckout />,
      },
      { path: "/apps/ecommerce/detail/:id", element: <EcommerceDetail /> },
      { path: "/apps/followers", element: <Followers /> },
      { path: "/apps/friends", element: <Friends /> },
      { path: "/apps/gallery", element: <Gallery /> },
      { path: "/user-profile", element: <UserProfile /> },
      { path: "/pages/casl", element: <RollbaseCASL /> },
      { path: "/pages/treeview", element: <Treeview /> },
      { path: "/pages/pricing", element: <Pricing /> },
      { path: "/pages/account-settings", element: <AccountSetting /> },
      { path: "/pages/faq", element: <Faq /> },
      {
        path: "/forms/form-elements/autocomplete",
        element: <MuiAutoComplete />,
      },
      { path: "/forms/form-elements/button", element: <MuiButton /> },
      { path: "/forms/form-elements/checkbox", element: <MuiCheckbox /> },
      { path: "/forms/form-elements/radio", element: <MuiRadio /> },
      { path: "/forms/form-elements/slider", element: <MuiSlider /> },
      { path: "/forms/form-elements/date-time", element: <MuiDateTime /> },
      { path: "/forms/form-elements/switch", element: <MuiSwitch /> },
      { path: "/forms/form-elements/switch", element: <MuiSwitch /> },
      { path: "/forms/quill-editor", element: <QuillEditor /> },
      { path: "/forms/form-layouts", element: <FormLayouts /> },
      { path: "/forms/form-horizontal", element: <FormHorizontal /> },
      { path: "/forms/form-vertical", element: <FormVertical /> },
      { path: "/forms/form-custom", element: <FormCustom /> },
      { path: "/forms/form-wizard", element: <FormWizard /> },
      { path: "/forms/form-validation", element: <FormValidation /> },
      { path: "/tables/basic", element: <BasicTable /> },
      { path: "/tables/collapsible", element: <CollapsibleTable /> },
      { path: "/tables/enhanced", element: <EnhancedTable /> },
      { path: "/tables/fixed-header", element: <FixedHeaderTable /> },
      { path: "/tables/pagination", element: <PaginationTable /> },
      { path: "/tables/search", element: <SearchTable /> },
      { path: "/charts/line-chart", element: <LineChart /> },
      { path: "/charts/gredient-chart", element: <GredientChart /> },
      { path: "/charts/doughnut-pie-chart", element: <DoughnutChart /> },
      { path: "/charts/area-chart", element: <AreaChart /> },
      { path: "/charts/column-chart", element: <ColumnChart /> },
      { path: "/charts/candlestick-chart", element: <CandlestickChart /> },
      { path: "/charts/radialbar-chart", element: <RadialbarChart /> },
      { path: "/ui-components/alert", element: <MuiAlert /> },
      { path: "/ui-components/accordion", element: <MuiAccordion /> },
      { path: "/ui-components/avatar", element: <MuiAvatar /> },
      { path: "/ui-components/chip", element: <MuiChip /> },
      { path: "/ui-components/dialog", element: <MuiDialog /> },
      { path: "/ui-components/list", element: <MuiList /> },
      { path: "/ui-components/popover", element: <MuiPopover /> },
      { path: "/ui-components/rating", element: <MuiRating /> },
      { path: "/ui-components/tabs", element: <MuiTabs /> },
      { path: "/ui-components/tooltip", element: <MuiTooltip /> },
      { path: "/ui-components/transfer-list", element: <MuiTransferList /> },
      { path: "/ui-components/typography", element: <MuiTypography /> },
      { path: "/widgets/cards", element: <WidgetCards /> },
      { path: "/widgets/banners", element: <WidgetBanners /> },
      { path: "/widgets/charts", element: <WidgetCharts /> },
      { path: "/404", element: <Error /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.forgotPassword, element: <ForgotPassword /> },
      { path: RouterName.auth.resetPassword, element: <ResetPassword /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
